import React, { Component } from 'react';
import AmountList from './amountList';
import Chart from './chart';
import Pricing from './pricing';
import I18n from "lib/i18n/i18n";
import SimilarItems from "../similarItems";
import {isMobile, rootUrl} from "../../helpers/ApplicationHelper";

class ListingCharts extends Component {
    constructor(props) {
        super(props);
    }

    render(){
        const {item, trends} = this.props;
        return(
            <div id="charts" className='graphs-section'>
                <Pricing estimations={trends.subset_values} diamondRange={trends.est_range} />
                <div className={'similar-items'}>
                    {
                        item && item['similar_items'] && item['similar_items'].length > 1 ?
                            <div>
                                <div className={'similar-title'}>{I18n.getString('itemPage::trends::listingTrends::similarItems::description')}</div>
                                <SimilarItems items={ item['similar_items']} hideSoldFor={false} item={item} goTo={(link, msg) => {
                                    window.open(link, isMobile() ? '_self' : '_blank');
                                }}/>
                            </div>
                            : null
                    }
                </div>
                <Chart name="gradingCertificates" subTitle={true} carat={trends && trends.size || null} />
                <AmountList itemId={this.props.itemId}/>
            </div>
        );
    }

}

export default ListingCharts;
